<app-header [title]="paper()?.title || 'Paper'"
            [enableGoBack]="true"
            [locationBack]="true">
  @if (paper()) {
    <button suffix class="back-btn" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Open paper context menu">
      <mat-icon>more_vert</mat-icon>
    </button>
  }
  @if (paper()) {
    <div class="screening-actions">
      @if (pdfUrl()) {
        <button
          mat-raised-button
          class="chat-btn"
          (click)="openChatDialog()">
          <mat-icon>chat</mat-icon>
          <span>Ask this paper</span>
        </button>
      }
      <button mat-raised-button (click)="startScreening()">
        <mat-icon>play_arrow</mat-icon>
        Start Screening
      </button>
    </div>
  }
</app-header>

@if (loading()) {
  <app-loading-card title="Loading your papers...">
    <p>Assembling research Avengers, chasing rogue citations, and convincing PDFs to cooperate. Almost there!</p>
  </app-loading-card>
} @else {
  @if (paper(); as paper) {

    <div class="header">
      <div class="info">
        <mat-icon>menu_book</mat-icon>
        <span>{{ paper.venue }} - {{ paper.year }} </span>
      </div>

      <div class="info">
        <mat-icon>lightbulb</mat-icon>
        <span> <b>{{ paper.citationCount || 0 }}</b> Citations</span>
        <span> <b>{{ paper.referenceCount || 0 }}</b> References</span>
      </div>

      <div class="info">
        <mat-icon>group</mat-icon>
        <span>{{ paper.authors }}</span>
      </div>

      <mat-chip-set>
        @if (paper.isOpenAccess) {
          <mat-chip class="open-access">
            <mat-icon matChipAvatar>lock_open</mat-icon>
            <span>Open Access</span>
          </mat-chip>
        }
      </mat-chip-set>

      <div class="link-group">
        @if (pdfUrl()) {
          <a mat-raised-button [href]="pdfUrl()" target="_blank">
            <mat-icon matChipAvatar>picture_as_pdf</mat-icon>
            <span>PDF</span>
          </a>
        } @else {
          <button mat-raised-button class="screening screening--no-file"
                  (click)="uploadFile()"
                  aria-label="No PDF found, or able to download, click here to upload"
                  matTooltip="No PDF found, or able to download, click here to upload"
          >
            <mat-icon matChipAvatar>upload</mat-icon>
            <span>PDF is unavailable. Upload it</span>
          </button>
        }
        @if (paper.url) {
          <a mat-raised-button [href]="paper.url" target="_blank" class="open-access--link">
            <mat-icon matChipAvatar>link</mat-icon>
            <span>Full text</span>
          </a>
        }
      </div>

    </div>

    <mat-tab-group [selectedIndex]="selectedTabIndex()"
                   (selectedIndexChange)="onTabChange({ index: $event })"
                   mat-stretch-tabs="false"
                   mat-align-tabs="start">
      <mat-tab label="Overview">
        <div class="editable">
          <h4>Abstract </h4>
          <button class="editable--btn" mat-icon-button (click)="toggleEditModeAbstract()">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        @if (!editAbstract()) {
          <p>{{ paper.abstractText }}</p>
        } @else {
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Abstract</mat-label>
            <textarea matInput
                      rows="13"
                      [(ngModel)]="paper.abstractText"
                      placeholder="No abstract available please set one"></textarea>
          </mat-form-field>
          <app-save-btn class="save-abstract-btn"
                        [element]="paper.abstractText"
                        (clicked)="update()"
                        (savingDone)="toggleEditModeAbstract()"
          ></app-save-btn>
        }

        @if (!isManuelCreated()) {
          @if (queries(); as queries) {
            <h4>
              Queries ({{ queries.length }})
            </h4>

            <mat-list class="query-list">
              @for (query of queries; track query.id) {
                <mat-list-item>
                  <span matListItemTitle>{{ query.source }}</span>
                  <span>{{ query.query }}</span>
                </mat-list-item>
              }
            </mat-list>
          }
        }

        <h4>
          Usage
        </h4>
        <div class="info-cards">
          <app-info-card
            title="Screened by Academate"
            subtitle="Automated screening powered by Academate (LLM)"
            icon="fact_check"
            [hasContent]="true">
            <div class="badge-group">
              @for (el of getTotalCounts(paper, false); track $index) {
                <app-badge color="GRAY" [text]="el.label">{{ el.value }}</app-badge>
              }
            </div>
          </app-info-card>
          <app-info-card
            title="Screened by you"
            subtitle="Manual verification by you"
            icon="fact_check"
            [hasContent]="true"
          >
            <div class="badge-group">
              @for (el of getTotalCounts(paper, true); track $index) {
                <app-badge color="GRAY" [text]="el.label">{{ el.value }}</app-badge>
              }
            </div>
          </app-info-card>
        </div>
      </mat-tab>
      <mat-tab label="Screening">

        @if (selectedScreeningProcess(); as process) {
          <div class="screening-overview">
            <div class="screening-overview--select">
              @if (paper.oldScreeningProcesses && paper.oldScreeningProcesses.length > 0) {
                <mat-form-field class="full-width">
                  <mat-label>Choose an option</mat-label>
                  <mat-select
                    [value]="selectedScreeningProcess()"
                    (valueChange)="selectedScreeningProcess.set($event)">
                    <mat-option [value]="paper.latestScreeningRun">Latest Screening</mat-option>
                    @for (run of paper.oldScreeningProcesses; track run.id) {
                      <mat-option [value]="run">Run: {{ run.createdAt | date:'short' }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              } @else {
                <p>Latest Screening</p>
              }
              <button class="btn" mat-icon-button [matMenuTriggerFor]="screeningMenu"
                      aria-label="Open screening context menu">
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>
            @if (process.screeningOne) {
              <div class="screening-run">
                <h3>Title/Abstract screening</h3>
                <app-screening-criterias-results
                  [runId]="process.screeningOne!.id"
                  [results]="process.screeningOne!.result"
                  [isScreeningOne]="false"
                  [paper]="paper"></app-screening-criterias-results>
              </div>
            }
            @if (process.screeningTwo) {
              <div class="screening-run">
                <h3>Full-Text screening</h3>
                <app-screening-criterias-results
                  [runId]="process.screeningTwo!.id"
                  [results]="process.screeningTwo!.result"
                  [isScreeningOne]="false"
                  [paper]="paper"></app-screening-criterias-results>
              </div>
            }
            <div class="screening-run screening-manual">
              <h3>Manual</h3>
              <app-research-paper-override-screening
                [paperId]="paper.id"
                [editable]="editMode()!"
                [process]="process"
                [projectId]="paper.projectId">
              </app-research-paper-override-screening>
            </div>
          </div>
          <p><strong>Criteria:</strong> {{ process.criteria }}</p>
          <p><strong>Language Model:</strong> {{ process.languageModel || 'N/A' }}</p>
          <p><strong>Embedding Model:</strong> {{ process.embeddingModel || 'N/A' }}</p>
        } @else {
          <p>No Screening found, you can already create manual results</p>
          <app-research-paper-override-screening
            [isNew]="true"
            [editable]="editMode()!"
            [paperId]="paper.id"
            [process]="selectedScreeningProcess()!"
            [projectId]="paper.projectId">
          </app-research-paper-override-screening>
        }
      </mat-tab>
      <mat-tab label="Summary">
        @defer (when selectedTabIndex() === 2) {
          <app-summary-paper [paper]="paper"></app-summary-paper>
        }
      </mat-tab>
      <mat-tab label="Study Snapshot">
        @defer (when selectedTabIndex() === 3) {
          <app-snapshot-table
            [paper]="paper">
          </app-snapshot-table>
        }
      </mat-tab>
      @if (pdfUrl()) {
        <mat-tab label="Original PDF">
          @defer (when selectedTabIndex() === 4) {
            @if (allowPDFRender()) {
              <ngx-extended-pdf-viewer
                [src]="pdfUrl()!"
                [height]="'100vh'"
              >
              </ngx-extended-pdf-viewer>
            } @else {
              <app-loading-card title="Wait for closing that chat">
                <p>You need to close that chat to see this view again</p>
              </app-loading-card>
            }
          }
        </mat-tab>
      }
    </mat-tab-group>
  } @else {
    <app-empty-state
      title="This paper could not be found!"
      subtitle="Either it doesn't exist or you don't have permission to access it."
      [icon]="'warning'"
    ></app-empty-state>
  }
}
<mat-menu #menu="matMenu">
  <button mat-menu-item
          class="delete-btn"
          (click)="deletePaper()">
    <mat-icon>delete_forever</mat-icon>
    Delete
  </button>
</mat-menu>

<mat-menu #screeningMenu="matMenu">
  <button mat-menu-item
          class="delete-btn"
          (click)="deleteScreening()">
    <mat-icon>delete_forever</mat-icon>
    Delete
  </button>
</mat-menu>
